<template>
	<div v-for="(room, index) in items" :key="room.pageID" class="row contentblock">
		<div class="columns column6 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
			<h3>{{ room.header }}</h3>
			<div v-parse-links v-html="room.overviewContent" />
			<slot
				name="extra-content"
				:facilities="room.facilities"
				:filename="localePath(`/${room.filename}`)"
				:bookingid="room.bookingID"
			/>
		</div>
		<div class="contentblock-image">
			<picture>
				<source v-if="room.imageOverviewWebp" :srcset="room.imageOverviewWebp" type="image/webp" />
				<source :srcset="room.imageOverview" />
				<img loading="lazy" :src="room.imageOverview" :alt="room.imageOverviewAlt" />
			</picture>
		</div>
	</div>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--contentblock-background-color);
	padding: 75px 0 0;
}

.background-light {
	background: var(--alternating-background-color);
}

.contentblock {
	margin: 0 auto;
	position: relative;
	border-top: 1px solid var(--contentblock-background-color);
	width: 100%;
	max-width: 100%;

	&:nth-child(even) {
		.contentblock-content {
			margin-left: calc(50% - 740px);
			margin-right: 0;
		}
	}
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 50%;
	z-index: 1;
}

.contentblock-content {
	padding: 120px 90px;
	margin: 0 auto;
	position: relative;
	z-index: 2;
	max-width: 740px;
	margin-right: calc(50% - 740px);

	.button,
	:deep(.button) {
		color: var(--button-nofill-color);
		border: 2px solid var(--button-nofill-color);
		padding: 12px 22px;
		background: none;

		&:hover {
			background: var(--button-nofill-color);
			color: #fff;
		}
	}

	.button-cta,
	:deep(.button-cta) {
		color: #fff;
		border: 2px solid var(--cta-color);
		padding: 12px 22px;
		background: var(--cta-color);

		&:hover {
			background: var(--cta-color-hover);
			color: #fff;
		}
	}
}

.row:nth-child(odd) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 1520px) {
	.contentblock-content {
		margin: auto !important;
	}
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}
}
</style>
